// extracted by mini-css-extract-plugin
export default {"productGallery":"UH-z","inQuickShop":"VH-z"};